export default __webpack_public_path__ + "static/media/dm.c17b5eb9.svg";